import { Card, TextField } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import AppData from './components/data-tables/data/dataTableData'
import Loader from 'examples/Loader'
import { useEffect, useState } from 'react'
import 'rsuite/dist/rsuite.min.css'
import CustomDataTable from '../Users/CustomDataTable'
import CreateBookingModal from './components/CreateModal'
import ChangeRequestDetailPage from './components/data-tables/ChangeRequestDetailPage'
import DiscountModal from './components/DiscountModal'

function Default() {
  const [changeReqBooking, setChangeReqBooking] = useState(null)

  const {
    dataTableData,
    handleRefresh,
    products,
    apps,
    loader,
    setDateRange,
    dateRange,
    pagination,
    handlePageChange,
    handleLimitChange,
    search,
    setSearch,
    handleSearch,
    excludeTesting,
    setExcludeTesting,
    statusFilter,
    handleStatusFilter,
    statusOptions,
    exportBookings,
    exporting,
    discountBooking,
    setDiscountBooking,
  } = AppData({ setChangeReqBooking })

  const [typingTimeout, setTypingTimeout] = useState(null)

  const handleDebouncedSearch = (value) => {
    setSearch(value)
    if (value.trim() === '') {
      if (typingTimeout) clearTimeout(typingTimeout)
      handleSearch()
      return
    }
    if (typingTimeout) clearTimeout(typingTimeout)
    const timeout = setTimeout(() => {
      handleSearch()
    }, 1000)
    setTypingTimeout(timeout)
  }

  const onLoad = () => { }
  useEffect(onLoad, [])

  // ── show detail page when a booking is selected ──
  if (changeReqBooking) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox p={3}>
                  <ChangeRequestDetailPage
                    booking={changeReqBooking}
                    onClose={() => setChangeReqBooking(null)}
                    onRefresh={() => {
                      handleRefresh()
                      setChangeReqBooking(null)
                    }}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      Bookings
                    </MDTypography>
                    <CreateBookingModal
                      products={products}
                      apps={apps}
                      handleRefresh={handleRefresh}
                    />
                  </MDBox>

                  <MDBox pt={3} px={3}>
                    {/* ── Toolbar: test toggle · status filter · Excel export ── */}
                    <MDBox
                      display="flex"
                      flexWrap="wrap"
                      alignItems="flex-end"
                      gap={2}
                      mb={2.5}
                      p={2}
                      sx={{
                        background: '#F8FAFC',
                        border: '1px solid #E5E9F2',
                        borderRadius: '12px',
                      }}
                    >
                      <button
                        style={{
                          background: excludeTesting ? 'green' : 'gray',
                          color: 'white',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          cursor: 'pointer',
                          height: '40px',
                        }}
                        onClick={() => {
                          const newValue = !excludeTesting
                          setExcludeTesting(newValue)
                          handleRefresh(newValue)
                        }}
                      >
                        {excludeTesting ? 'Include Test Bookings' : 'Exclude Test Bookings'}
                      </button>

                      <MDBox display="flex" flexDirection="column" gap={0.75}>
                        <span
                          style={{
                            fontSize: '11px',
                            fontWeight: 700,
                            letterSpacing: '0.4px',
                            textTransform: 'uppercase',
                            color: '#8392AB',
                          }}
                        >
                          Filter by Status
                        </span>
                        <select
                          value={statusFilter}
                          onChange={(e) => handleStatusFilter(e.target.value)}
                          style={{
                            padding: '0 36px 0 14px',
                            height: '40px',
                            borderRadius: '8px',
                            border: '1px solid #D7DCE5',
                            background:
                              "white url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23556080' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\") no-repeat right 12px center",
                            color: '#344767',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 600,
                            minWidth: '190px',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            MozAppearance: 'none',
                          }}
                        >
                          {statusOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </MDBox>

                      {/* Export current filter to Excel */}
                      <button
                        onClick={exportBookings}
                        disabled={exporting}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '9px',
                          background: exporting ? '#9CA3AF' : '#1E7E34',
                          color: 'white',
                          padding: '0 18px',
                          height: '40px',
                          borderRadius: '8px',
                          border: 'none',
                          cursor: exporting ? 'not-allowed' : 'pointer',
                          fontWeight: 600,
                          fontSize: '14px',
                          marginLeft: 'auto',
                          boxShadow: exporting
                            ? 'none'
                            : '0 3px 8px rgba(30, 126, 52, 0.25)',
                        }}
                      >
                        {exporting ? (
                          <span
                            style={{
                              width: '16px',
                              height: '16px',
                              border: '2px solid rgba(255,255,255,0.5)',
                              borderTopColor: 'white',
                              borderRadius: '50%',
                              display: 'inline-block',
                              animation: 'spin 0.7s linear infinite',
                            }}
                          />
                        ) : (
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                          </svg>
                        )}
                        {exporting ? 'Exporting…' : 'Export to Excel'}
                      </button>

                      <style>
                        {'@keyframes spin { to { transform: rotate(360deg); } }'}
                      </style>
                    </MDBox>

                    <CustomDataTable
                      table={dataTableData}
                      canSearch={false}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      pagination={pagination}
                      onPageChange={handlePageChange}
                      onLimitChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
      <DiscountModal
        open={!!discountBooking}
        onClose={() => setDiscountBooking(null)}
        booking={discountBooking}
        onSuccess={handleRefresh}
      />
    </DashboardLayout>
  )
}

export default Default